$(document).ready(function () {
  let lastScrollTop = 0;

  $(window).on('scroll', function () {
    let st = $(this).scrollTop();
    if (st > lastScrollTop) {
      //downscroll code
      $(".logo-incograf").css({
        bottom: "40%",
        transition: 'bottom 0.9s ease-in-out'
      });
    }

    if (st === 0) {
      $(".logo-incograf").css({
        //back to original position
        bottom: "20%",
        transition: 'bottom 0.9s ease-in-out'
      });
    }

    lastScrollTop = st;
  });

  $('#video-block .anchor-to-video').on('click', function (evt) {
    let videoUrl = $('#video-block video source').attr('src');
    let loader = $('#video-block video').attr('poster');
    let template =
      `<video preload='metadata'
              poster='${loader}'
              autoplay controls playsinline
              src='${videoUrl}'></video>`

    $('#fullscreen-modal .media-item').append(template);
    $('#fullscreen-modal').css('display', 'flex');
  });

  $('#video-block .anchor-to-youtube').on('click', function (evt) {
    let videoUrl =$('#video-block iframe').attr('src').split("?")[0];
    console.log(videoUrl);

    let templateModal = `<div class="embed-container">
                            <iframe id="youtubeIframeModal" src="${videoUrl}?autoplay=0&mute=0&controls=1&rel=0&vq=hd1080&origin=${baseUrl}" frameborder="0" allowfullscreen></iframe>
                         </div>`;

    $('#fullscreen-modal .media-item').append(templateModal);
    $('#fullscreen-modal').css('display', 'flex');
  });

  document.addEventListener('mousemove', function (e) {
    let x = e.clientX;
    let y = e.clientY;
    document.getElementById('video-hp').style.setProperty('--cursorX', x + 'px');
    document.getElementById('video-hp').style.setProperty('--cursorY', y + 'px');
  });

  var controller = new ScrollMagic.Controller();

  // build scenes elements of project section
  var showElementsProj = document.getElementsByClassName("objProj");
  for (var i = 0; i < showElementsProj.length; i++) {
    new ScrollMagic.Scene({
      triggerElement: showElementsProj[i],
      offset: 50,
      triggerHook: 0.9,
      //reverse: false
    })
      .setClassToggle(showElementsProj[i], "visible")
      //.addIndicators({name: "showElementsProj" })
      .addTo(controller);
  }

  // build scenes left side of services section
  var showTxtServices = document.getElementsByClassName("objServices");

  for (var j = 0; j < showTxtServices.length; j++) { // create a scene for each element
    new ScrollMagic.Scene({
      triggerElement: showTxtServices[j], // y value not modified, so we can use element as trigger as well
      offset: 50,												 // start a little later
      triggerHook: 0.9,
      //reverse: false
    })
      .setClassToggle(showTxtServices[j], "visible") // add class toggle
      //.addIndicators({name: "obj " + (j+1) }) // add indicators (requires plugin)
      .addTo(controller);
  }

  var showListServices = document.getElementById('services-block').getElementsByClassName("list")[0].children;

  for (var k = 0; k < showListServices.length; k++) { // create a scene for each element
    new ScrollMagic.Scene({
      triggerElement: showListServices[k], // y value not modified, so we can use element as trigger as well
      offset: 50,												 // start a little later
      triggerHook: 0.9,
      //reverse: false
    })
      .setClassToggle(showListServices[k], "visibleListServices") // add class toggle
      //.addIndicators({name: "obj " + (k+1) }) // add indicators (requires plugin)
      .addTo(controller);
  }
})
